<template>
  <div>
    <base-instance-selection
      :headerInfo="headerInfo"
      :buttonText="buttonText"
      :headers="headers"
      :rows="getLoanTypeData"
      @selectfilteredMenu="selectfilteredMenu"
      :loanCategories="loanCategories"
      @compare="compareData"
      @createNew="createNewLoan"
      @rowSelected="onSelectedLoan"
      @duplicateRow="duplicateRow"
      @renameRow="renameRow"
      @deleteRow="deleteRow"
      :actionButtonText="actionButtonText"
      :imagepath="imagepath"
    >
    </base-instance-selection>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    >
      <template #dialogBody v-if="!userInputText.isHide">
        <mds-input
          autocomplete="off"
          :label="''"
          v-model="userInputText.value"
          :error="userInputText.isError"
          :errorText="userInputText.errorText"
          :maxlength="maxValue"
        ></mds-input>
        <span>{{ userEnterCharCount }}/{{ maxValue }}</span></template
      >
    </confirmation-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { BaseInstanceSelection } from "../../component/loanSelection";
import { ConfirmationDialog } from "../../component/tool";
import { mapActions } from "vuex";
import Loan from "../../models/loan";
import MdsInput from "@mds/input";
import { LoanService } from "../../services";
import { LoanSave, ToolSelection, UserEvent } from "../../mixin";
import {
  SET_SELECTED_Liablity_INFORMATION,
  SET_Liablity_INFORMATION,
  GET_AUTH_INFORMATION,
  SET_COMPARE_LOAN_INFO,
  GET_CLIENT_INFORMATION,
  SET_ALL_LIABILITY_INFORMATION,
  SET_LOADER_VISIBILITY,
} from "../../helpers/vuex-constants";
import {
  LoanSelected,
  CompareAction,
  tabCreatedAction,
  tabSelectedAction,
  DuplicateAction,
  RenameAction,
  DeleteAction,
} from "../../helpers/userEvent";
import { DialogAction, EntityTypes } from "../../helpers/constant";
import { CommonHelper } from "../../helpers";
import {
  GET_LIABLITY_INFORMATION,
  SET_NOTIFICATION_SUMMARY,
} from "../../helpers/vuex-constants";

export default {
  name: "loan-instance-Selection",
  components: {
    BaseInstanceSelection,
    ConfirmationDialog,
    MdsInput,
  },
  props: {
    liabilityInfo: {
      type: Array,
    },
  },
  mixins: [LoanSave, ToolSelection, UserEvent],
  data() {
    return {
      headerInfo: {
        heading:
          "Select existing or create new instance from the engagement tools",
        headingIconText: "Click action button for other options",
        subHeading: "Select checkbox to start compare instances",
      },
      buttonText: "Create New Instance",

      actionButtonText: "Action",
      maxValue: 60,
      userInputText: {
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
        payload: {},
        value: "",
      },
      headers: [
        {
          fieldType: "checkbox",
          fieldName: "isSelected",
          style: { width: "45px" },
        },
        {
          text: "Instance Name",
          fieldType: "metadata",
          fieldDescription: "description",
          split: " ",
          metadata: [
            {
              heading: "Amount",
              key: "amount",
            },
            {
              heading: "Interest",
              key: "text",
            },
          ],
          styleRow: { "padding-left": "4px" },
        },
        {
          text: "",
          fieldType: "tag",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",

          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "profile",
          fieldAmount: "",
          fieldText: "",
          fieldDescription: "",
          style: { width: "70px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
        {
          text: "Last Modified",
          fieldType: "date",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          fieldName: "date",
          align: "right",
          sortable: true,
          sorted: 1,
          style: { width: "100px" },
          styleRow: { "vertical-align": "middle" },
        },
        {
          text: "",
          fieldType: "action",
          fieldAmount: "",
          fieldText: "text",
          fieldDescription: "",
          style: { opacity: "0px", width: "100px" },
          styleRow: { "text-align": "center", "vertical-align": "middle" },
        },
      ],
      rows: {
        type: Array,
      },
      selectedValue: 1,

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          title: "Discard Changes",
          rightButtons: [
            {
              text: "Cancel",
              variation: "secondary",
              emitevent: "cancel_Click",
              id: 1,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "submit_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },

  async created() {
    await this.mapData();
  },

  methods: {
    ...mapActions("loan", {
      setAllLiablityInformation: SET_ALL_LIABILITY_INFORMATION,
    }),
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    onSelectedLoan(selectedLoan) {
      let selectedLoanInfo = [];
      if (selectedLoan) {
        selectedLoanInfo = this.getLiablityInformation.filter(
          (sr) =>
            sr.liabilityId == selectedLoan.liabilityId &&
            sr.liabilityGuid == selectedLoan.liabilityGuid
        );
      }

      if (selectedLoanInfo && selectedLoanInfo.length > 0) {
        let cloneSelectedLoan = Object.assign({}, selectedLoanInfo[0]);

        this.setSelectedLiabilityInfo(cloneSelectedLoan);
        this.saveUserSession(
          LoanSelected,
          tabSelectedAction,
          selectedLoanInfo[0].isFromFact ? "FactFind" : ""
        );
        this.$router.push({ name: "loan-engagement-tool" });
      }
    },

    duplicateRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Duplicate;

      this.userInputText.payload = data;
      if (data) {
        if (data.description.length >= this.maxValue)
          this.userInputText.value =
            "Copy of " +
            data.description.substring(0, this.maxValue - 8) +
            "...";
        else this.userInputText.value = "Copy of " + data.description;
        this.confirmationDialogList[0].title =
          "Duplicate " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }

      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Duplicate";
    },
    renameRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = false;
      this.userInputText.id = DialogAction.Rename;
      if (data) {
        this.userInputText.payload = data;
        this.confirmationDialogList[0].title =
          "Rename " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }
      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Rename";
    },
    deleteRow(data) {
      this.resetDialogField();
      this.userInputText.isHide = true;
      this.userInputText.id = DialogAction.Delete;
      this.userInputText.payload = data;
      if (data) {
        this.confirmationDialogList[0].title =
          "Delete " +
          data.description.replaceAll("<", "&lt;").replaceAll(">", "&gt;");
      }

      this.confirmationDialogList[0].toggle = true;
      this.confirmationDialogList[0].rightButtons[1].text = "Delete";
    },
    submit_Click() {
      if (this.userInputText.id == DialogAction.Delete) {
        this.deleteLoan(
          this.userInputText.payload.liabilityGuid,
          this.userInputText.payload.description,
          this.getAuthInformation.encClientId
        );
      } else if (
        this.userInputText.id == DialogAction.Duplicate &&
        this.validateUserInput()
      ) {
        this.copyLoan(
          this.userInputText.payload.liabilityGuid,
          this.userInputText.value
        );
      } else if (
        this.userInputText.id == DialogAction.Rename &&
        this.validateUserInput()
      ) {
        this.renameLoan(
          this.userInputText.payload.liabilityGuid,
          this.userInputText.value,
          this.getAuthInformation.encClientId
        );
      }
    },
    async copyLoan(liabilityGuid, description) {
      let selectedLoan = Object.assign(
        {},
        this.getLiablityInformation.filter(
          (sr) => sr.liabilityGuid == liabilityGuid
        )[0]
      );
      selectedLoan.description = description;
      let loanModel = this.createLoanModel(selectedLoan);
      this.setLoaderVisibility(true);
      let response = await LoanService.createCopyOfLoan(loanModel);
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Loan instance ${description} has been added.`
        );
        let selectedLoanModel = [];
        response.data.lastModifiedDateTime = new Date()
          .toISOString()
          .slice(0, 10);
        selectedLoanModel.push(response.data);
        let loanUIModel = Loan.setLoanInformation(
          selectedLoanModel,
          this.clientInformation
        );
        let allLiability = this.getLiablityInformation.concat(loanUIModel[0]);
        this.setLoaderVisibility(true);
        this.setAllLiablityInformation(allLiability);
        this.setLoaderVisibility(false);
        await this.mapData();
        this.saveUserSession(LoanSelected, DuplicateAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to create copy of the ${description} instance .`
        );
      }
    },
    async renameLoan(liabilityGuid, description, encClientId) {
      let loan = {
        ID: liabilityGuid,
        Value: description,
        encClientId: encClientId,
      };
      this.setLoaderVisibility(true);
      let response = await LoanService.updateLoan(loan);
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Loan instance ${description} has been updated.`
        );
        let index = this.getLiablityInformation.findIndex(
          (sr) => sr.liabilityGuid == liabilityGuid
        );
        this.getLiablityInformation[index].description = description;
        this.getLiablityInformation[index].lastModifiedDateTime = new Date()
          .toISOString()
          .slice(0, 10);
        this.setAllLiablityInformation(this.getLiablityInformation);
        this.mapData();
        this.saveUserSession(LoanSelected, RenameAction, "");
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to rename the ${description} instance .`
        );
      }
    },
    async deleteLoan(liabilityGuid, description, encClientId) {
      this.setLoaderVisibility(true);
      let response = await LoanService.deleteLoan(liabilityGuid, encClientId);
      this.setLoaderVisibility(false);
      if (response && response.status == 200) {
        this.setNotificationMessage(
          "success",
          `Loan instance ${description} has been deleted.`
        );
        let index = this.getLiablityInformation.findIndex(
          (sr) => sr.liabilityGuid == liabilityGuid
        );
        this.getLiablityInformation.splice(index, 1);
        this.setLoaderVisibility(true);
        this.setAllLiablityInformation(this.getLiablityInformation);
        this.setLoaderVisibility(false);
        this.saveUserSession(LoanSelected, DeleteAction, "");
        this.mapData();
      } else {
        this.setNotificationMessage(
          "error",
          `Failed to delete the ${description} instance .`
        );
      }
    },

    setNotificationMessage(variation, message) {
      this.setNotificationSummary({
        isShow: true,
        variation: variation,
        text: message,
      });
    },

    resetDialogField() {
      this.userInputText = {
        value: "",
        isError: false,
        errorText: [],
        isHide: false,
        id: 0,
      };
    },
    validateUserInput() {
      let inputText = this.userInputText.value;
      if (!inputText) {
        return this.setErrorMessage();
      }
      let index = this.rows.findIndex(
        (sr) =>
          sr.description.toLowerCase() == this.userInputText.value.toLowerCase()
      );
      if (index >= 0) {
        return this.setErrorMessage(
          "The instance name is already taken, Use a different name to continue."
        );
      }
      return true;
    },
    setErrorMessage(errorText) {
      this.userInputText.isError = true;
      this.userInputText.errorText = [];
      this.userInputText.errorText.push(errorText);
      this.confirmationDialogList[0].toggle = true;
      return false;
    },
    cancel_Click() {
      this.confirmationDialogList[0].toggle = false;
    },
    createNewLoan() {
      let parentClientIndex = this.clientInformation.findIndex(
        (sr) => sr.entityType == 1
      );
      if (parentClientIndex >= 0) {
        let loanModel = Loan.getEmptyLoanModel(
          this.clientInformation[parentClientIndex]
        );
        this.setAllLiablityInformation(
          this.getLiablityInformation.concat(loanModel)
        );
        this.setSelectedLiabilityInfo(loanModel);
        this.saveUserSession(LoanSelected, tabCreatedAction, CompareAction);
        this.$router.push({ name: "loan-engagement-tool" });
      }
    },
    compareData(data) {
      let selectedLoans = [];
      let selectedLoan = [];
      let cloneSelectedLoan = {};
      for (let i = 0; i < data.length; i++) {
        selectedLoan = this.getLiablityInformation.filter(
          (sr) => sr.liabilityGuid == data[i].liabilityGuid
        );
        cloneSelectedLoan = Object.assign({}, selectedLoan[0]);
        selectedLoans.push(cloneSelectedLoan);
      }
      this.setCompareLoanInfo(selectedLoans);
      this.saveUserSession(
        LoanSelected,
        CompareAction,
        selectedLoans.length + ""
      );
      this.$router.push({ name: "compare-loan" });
    },
    ...mapActions("loan", {
      setCompareLoanInfo: SET_COMPARE_LOAN_INFO,
      setSelectedLiabilityInfo: SET_SELECTED_Liablity_INFORMATION,
    }),

    ...mapMutations("loan", {
      reSetLiablityInformation: SET_Liablity_INFORMATION,
    }),
    ...mapActions({
      setLiablityInformation: SET_Liablity_INFORMATION,
    }),
    async mapData() {
      let clid = this.getAuthInformation.encClientId;
      this.setLoaderVisibility(true);
      await this.setLiablityInformation(clid);
      this.setLoaderVisibility(false);
      let parentClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.client
      );
      let partnerClientInfo = this.clientInformation.findIndex(
        (sr) => sr.entityType == EntityTypes.partner
      );

      //this.liabilityInfo = this.getLiablityInformation;
      let arr = this.getLiablityInformation.map((r) => {
        let p = {};

        let actualDate = r.lastModifiedDateTime.slice(0, 10);
        let currentDate = new Date().toISOString().slice(0, 10);
        p.date =
          CommonHelper.formatDate(actualDate) ==
          CommonHelper.formatDate(currentDate)
            ? "Today"
            : CommonHelper.formatDate(actualDate);
        p.text = `${CommonHelper.addConstantSymbolInNumber(
          r.interestRate.toFixed(2),
          "%"
        )}`;
        p.profiles = this.getProfileName(
          r.entityType,
          r.clientName,
          partnerClientInfo,
          parentClientInfo
        );
        p.amount = CommonHelper.convertIntoCurrencyWithoutDecimal(
          r.outstandingAmount
        );
        p.tagName = r.loanTypeName;
        p.name = "Amount";
        p.entityName = r.clientName
          ? r.clientName.replace(/(^MRS|MR|MISS)/gi, "")
          : "";

        p.description = r.description;
        p.liabilityId = r.liabilityId;
        p.liabilityTypeId = r.liabilityTypeId;
        p.interestRate = r.interestRate;
        p.repaymentAmount = r.repaymentAmount;
        p.termInYears = r.termInYears;
        p.durationType = r.durationType;
        p.clientName = r.clientName;
        p.loanTypeName = r.loanTypeName;
        p.loanTypeId = r.loanTypeId;
        p.liabilityGuid = r.liabilityGuid;
        p.liabilityGuid = r.liabilityGuid;
        p.isSelected = false;
        p.isFromFact = r.isFromFact ? "FactFind" : "";
        p.actionButtons = r.isFromFact
          ? [
              {
                emitevent: "duplicateRow",
                icon: "group",
                text: "Duplicate",
                id: 1,
              },
            ]
          : [
              {
                emitevent: "duplicateRow",
                icon: "group",
                text: "Duplicate",
                id: 1,
              },
              { emitevent: "renameRow", icon: "pencil", text: "Rename", id: 2 },
              { emitevent: "deleteRow", icon: "trash", text: "Delete", id: 3 },
            ];

        return p;
      });
      this.rows = arr;
    },
    selectfilteredMenu(data) {
      this.selectedValue = data.value;
    },
    genericMethodClick(function_name) {
      this[function_name]();
    },
    GetMenuObject(value, active, text) {
      return {
        value: value,
        active: value == active,
        text: text,
      };
    },
  },

  computed: {
    userEnterCharCount() {
      if (!this.userInputText.value) {
        return 0;
      } else {
        var spaceCount = this.userInputText.value.match(/^\s*/)[0].length;
        spaceCount = spaceCount < 0 ? 0 : spaceCount;
        if (this.userInputText.value.length > this.maxValue) {
          return this.maxValue;
        } else {
          return this.userInputText.value.length - spaceCount;
        }
      }
    },
    imagepath() {
      return require("../../assets/icons/Search.svg");
    },
    loanCategories() {
      let menudata = [];
      menudata.push(this.GetMenuObject(1, this.selectedValue, "Recent"));
      if (
        this.rows.length > 0 &&
        this.rows.filter(
          (sr) => sr.loanTypeId == 5 // personal Loan
        ).length > 0
      ) {
        menudata.push(
          this.GetMenuObject(2, this.selectedValue, "Personal Loan")
        );
      }
      if (
        this.rows.length > 0 &&
        this.rows.filter(
          (sr) => sr.loanTypeId == 9 // Home Loan
        ).length > 0
      ) {
        menudata.push(this.GetMenuObject(3, this.selectedValue, "Home Loan"));
      }
      if (
        this.rows.length > 0 &&
        this.rows.filter(
          (sr) => sr.loanTypeId !== 5 && sr.loanTypeId !== 9 // Others/uncategorized
        ).length > 0
      ) {
        menudata.push(this.GetMenuObject(4, this.selectedValue, "Others"));
      }
      return menudata;
    },
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
      clientInformation: GET_CLIENT_INFORMATION,
    }),
    ...mapGetters("loan", {
      getLiablityInformation: GET_LIABLITY_INFORMATION,
    }),
    getLoanTypeData() {
      let selectedLoanType = "";
      if (this.selectedValue == 1) {
        return this.rows;
      } else if (this.selectedValue == 2) {
        selectedLoanType = this.rows.filter(
          (sr) => sr.loanTypeId == 5 // personal Loan
        );
        return selectedLoanType;
      } else if (this.selectedValue == 3) {
        selectedLoanType = this.rows.filter(
          (sr) => sr.loanTypeId == 9 // Home Loan
        );
        return selectedLoanType;
      } else if (this.selectedValue == 4) {
        selectedLoanType = this.rows.filter(
          (sr) => sr.loanTypeId !== 5 && sr.loanTypeId !== 9 // Others/uncategorized
        );
        return selectedLoanType;
      } else {
        return this.rows;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
